import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ModalController, PopoverController} from '@ionic/angular';
import {AccountPaymentFavoriteService} from '@wlp/ui-bs-account-payment-favorite';
import {BilletFineRequestDto, BilletLotService, BilletService, BilletTrafficTicketTypeEnum} from '@wlp/ui-bs-cashin';
import {UserInfoService} from '@wlp/ui-bs-login';
import {FineDto} from '@wlp/ui-px-cashin';
import * as moment from 'moment';
import {LoadingService} from 'src/app/core/layout/services/loading.service';

@Component({
  selector: 'ui-t-form-fine',
  templateUrl: './form-fine.html',
  styleUrls: ['./form-fine.scss'],
})
export class FormFine implements OnInit {
  @Input() public fine: FineDto;
  @Input() public billetDueTime: Date;
  @Output() public submitForm = new EventEmitter<string>();
  @Output() public onCancel = new EventEmitter<string>();
  public enableFine = false;
  public finesForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public modalController: ModalController,
    public popoverController: PopoverController,
    public router: Router,
    protected userInfoService: UserInfoService,
    public billetService: BilletService,
    public billetLotService: BilletLotService,
    public accountPaymentFavoriteService: AccountPaymentFavoriteService,
    private cd: ChangeDetectorRef,
    private loadingService: LoadingService,
  ) {
    moment.locale('pt-br');
  }

  public ngOnInit() {
    this.createFinesForm();
    if (this.fine.type != BilletTrafficTicketTypeEnum.FREE_TICKET) {
      this.enableFine = true;
    }
  }

  public getFine(): BilletFineRequestDto {
    const fineInputToEnum = (value: string): BilletTrafficTicketTypeEnum => {
      switch (value) {
        case 'FIXED_TICKET':
          return BilletTrafficTicketTypeEnum.FIXED_TICKET;
        case 'PROPORTIONAL_TICKET':
          return BilletTrafficTicketTypeEnum.PROPORTIONAL_TICKET;
        case 'FREE_TICKET':
        default:
          return BilletTrafficTicketTypeEnum.FREE_TICKET;
      }
    };

    const fineType = this.finesForm.controls.fineTypes.value;
    const finevalue = this.finesForm.controls.amount.value;
    const fineDays = (this.finesForm.controls.limitAmount.value).trim().split('/').reverse().join('-');
    const selectedFine = fineInputToEnum(this.enableFine ? fineType : null);

    return {
      type: selectedFine,
      value: finevalue,
      expirationDate: fineDays,
    };
  }

  public createFinesForm() {
    let trafficTicketDays = '';

    if (this.fine.type !== 'FREE_TICKET'){
      trafficTicketDays = this.calculateTrafficTicketDeadline(this.fine.days);
    }

    this.finesForm = this.formBuilder.group({
      fineTypes: this.formBuilder.control(this.fine.type, Validators.compose([Validators.required])),
      amount: this.formBuilder.control(this.fine.value, Validators.compose([Validators.required])),
      limitAmount: this.formBuilder.control(trafficTicketDays, Validators.compose([Validators.required])),
    });
    this.loadingService.hide();
  }

  public handleClickSaveButton() {
    this.submitForm.emit();
  }

  public cancel() {
    this.onCancel.emit();
  }

  public calculateTrafficTicketDeadline(billetTrafficTicketDays: string) {
    const billetTrafficTicketDaysNumber = parseInt(billetTrafficTicketDays);
    const billetDueTimeMoment = moment(this.billetDueTime, 'YYYY-MM-DDTHH:mm:ss.SSSZ');
    const billetTrafficTicketDeadline = billetDueTimeMoment.add(billetTrafficTicketDaysNumber, 'days');
    const formattedDeadline = billetTrafficTicketDeadline.format('DD/MM/YYYY');
    return formattedDeadline;

  }
}
